import LocalizedStrings from 'localized-strings';

import { InvoiceType } from '__generated__/GQL';

export default new LocalizedStrings({
  en: {
    [InvoiceType.Invoice]: {
      hint: 'Previous invoice number: {0}',
      label: 'New invoice number',
    },
    [InvoiceType.Quote]: {
      hint: 'Previous quote number: {0}',
      label: 'New quote number',
    },
  },
  fr: {
    [InvoiceType.Invoice]: {
      hint: 'Le numéro de la facture précédente est : {0}',
      label: 'Numéro de la nouvelle facture',
    },
    [InvoiceType.Quote]: {
      hint: 'Le numéro du devis précédent est : {0}',
      label: 'Numéro du nouveau devis',
    },
  },
} as const);
